import { ReactElement } from "react";
import {
  AccordionBootstrap,
  AccordionBootstrapProps,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  AccordionType,
} from "@/shared/components/AccordionBootstrap";

export interface AccordionItemProps {
  value: string;
  title: ReactElement;
  children: ReactElement;
}

export type AccordionProps<T extends AccordionType> = Omit<
  AccordionBootstrapProps<T>,
  "content" | "type"
> & {
  content: AccordionItemProps[];
  type: T;
};

export function Accordion<T extends AccordionType>({
  content,
  type,
  ...props
}: AccordionProps<T>) {
  return (
    <AccordionBootstrap
      {...(props as unknown as AccordionBootstrapProps<T>)}
      type={type}
      className="flex-col-gap-4"
      collapsible
    >
      {content.map(({ title, value, children }) => (
        <AccordionItem key={value} value={value}>
          <AccordionTrigger>{title}</AccordionTrigger>
          <AccordionContent>{children}</AccordionContent>
        </AccordionItem>
      ))}
    </AccordionBootstrap>
  );
}
